import { render, staticRenderFns } from "./Breakdown.vue?vue&type=template&id=6de9fd45&"
import script from "./Breakdown.vue?vue&type=script&lang=js&"
export * from "./Breakdown.vue?vue&type=script&lang=js&"
import style0 from "./Breakdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports